export const queryKeys = {
  DEBIT_LIST: 'DEBIT_LIST'
};
